import { useState } from "react";
import { useToast } from "@chakra-ui/react";
import { dimensionsKeys, showErrorToast } from "../../../../../../utils";
import { useGetDimensions } from "../../../../../../hooks/query/dimensions";

/**
 * Shared hook for parent-based dimension filtering in Scope 3 category modals.
 * Mirrors the logic in DimensionsGrid/GridItemsSection for Scope 1/2.
 */
export function useDimensionFiltering({ dimensionItems, editData, watchFieldArray }) {
  const toast = useToast();
  const [changedRowIndex, setChangedRowIndex] = useState(-1);
  const [initialDimensionsData, setInitialDimensionsData] = useState(null);
  const [rowDimensionsData, setRowDimensionsData] = useState({});

  const getDimensionsQueryParams = () => {
    const queryParams = {};

    dimensionsKeys.forEach(key => {
      if (changedRowIndex !== -1) {
        const val = watchFieldArray[changedRowIndex]?.[`${key}Item`];
        if (val !== undefined && val !== null && val !== "") {
          queryParams[`${key}Item`] = val;
        }
      } else {
        if (editData) {
          const dimItem = editData[`${key}Item`];
          if (dimItem !== null && dimItem !== undefined && dimItem !== "") {
            queryParams[`${key}Item`] = dimItem;
          }
        } else if (dimensionItems) {
          if (dimensionItems[`${key}Item`] !== null && dimensionItems[`${key}Item`] !== undefined) {
            queryParams[`${key}Item`] = dimensionItems[`${key}Item`];
          }
        }
      }
    });

    return queryParams;
  };

  useGetDimensions(getDimensionsQueryParams(), {
    onSuccess: data => {
      if (changedRowIndex !== -1) {
        setRowDimensionsData(prev => ({ ...prev, [changedRowIndex]: data }));
      } else {
        setInitialDimensionsData(data);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0,
    enabled: changedRowIndex !== -1 || initialDimensionsData === null
  });

  const getFilteredItems = (dimKey, rowIndex) => {
    if (rowDimensionsData[rowIndex]?.[dimKey]) {
      return rowDimensionsData[rowIndex][dimKey].items;
    }
    if (initialDimensionsData?.[dimKey]) {
      return initialDimensionsData[dimKey].items;
    }
    return null;
  };

  return {
    initialDimensionsData,
    getFilteredItems,
    setChangedRowIndex
  };
}
